module.exports = __webpack_public_path__ + "img/T1B_xh_5.3aebb1c4.png";